import { render, staticRenderFns } from "./SoundQuestion.vue?vue&type=template&id=69d6923e&scoped=true&"
import script from "./SoundQuestion.vue?vue&type=script&lang=ts&"
export * from "./SoundQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./SoundQuestion.vue?vue&type=style&index=0&id=69d6923e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d6923e",
  null
  
)

export default component.exports